@if (preAuthority) {
  <div>
    <mat-expansion-panel
      (closed)="preAuthorityCurtainOpened = false"
      (opened)="preAuthorityCurtainOpened = true"
      class="curtains">
      <mat-expansion-panel-header [collapsedHeight]="'70px'" [expandedHeight]="'70px'">
        <mat-panel-title class="pre-authority-header-grid">
          <div>
            @if (preAuthority.preAuthorizedDate) {
              <div class="received-date">
                {{ preAuthority.preAuthorizedDate | dateepoch: timezone }}
                {{ preAuthority.preAuthorizedDate | time: timezone }}
              </div>
            }
            <div class="authority-number">
              <div class="title-1">Self-Authority</div>
              <div class="authorised-box" appHighlightStatus="ISSUED">ISSUED</div>
            </div>
          </div>
          @if (!preAuthorityCurtainOpened) {
            <div>
              @if (preAuthority.ownerContribution) {
                <div class="labels body-2">Owner Contribution</div>
                <div class="data-values subtitle-2">$ {{ preAuthority.ownerContribution | number: '1.2-2' }}</div>
              }
            </div>
          }
          <div class="vehicle-value">
            @if (preAuthority.vehicleValue) {
              <div class="labels body-2">Vehicle Value</div>
              <div class="data-values subtitle-2">$ {{ preAuthority.vehicleValue | number: '1.2-2' }}</div>
            }
          </div>
        </mat-panel-title>
        <mat-panel-description class="kebab-panel">
          <div class="w-40 secondary-icon">
            <pdf-button (openPDF)="openPdfReport.emit()" />
          </div>
          @if (!quoteSubmitted) {
            <div class="secondary-icon">
              <button
                matIconButton
                [matMenuTriggerFor]="kebabMenu"
                (click)="$event.stopPropagation()">
                <mat-icon>more_vert_32px</mat-icon>
              </button>
            </div>
          }
        </mat-panel-description>
      </mat-expansion-panel-header>
      <mat-divider></mat-divider>
      <div class="info-guidance subtitle-2">
        <mat-icon>info_outlined</mat-icon>
        <span>This job is self-authorised, you can proceed with the work and send the quote separately.</span>
      </div>
      <form [formGroup]="preAuthorityForm">
        <div class="pre-authority-grid">
          <mat-form-field class="field">
            <mat-label>Owner Contribution</mat-label>
            <input (blur)="formatOwnerContribution()" formControlName="ownerContribution" matInput />
            @if (ownerContribution.value) {
              <mat-icon class="ownerContribution-input-icon" matSuffix>attach_money_24px</mat-icon>
            }
            @if (!ownerContribution.valid) {
              <mat-error> This is not a valid amount </mat-error>
            }
          </mat-form-field>
        </div>
      </form>
    </mat-expansion-panel>
  </div>
}

<mat-menu #kebabMenu="matMenu" xPosition="before" class="job-progress">
  <ng-template matMenuContent>
    <button mat-menu-item (click)="confirmWithdrawSelfAuthority()">Withdraw self-authority</button>
  </ng-template>
</mat-menu>
